(function() {
  // Initialize LayoutHub page
  if (typeof window.LHPAGE === 'undefined') {
    window.LHPAGE = {};
  }

  // Add smooth scrolling for anchor links
  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  });

  // Add animation on scroll
  const animateOnScroll = function() {
    const elements = document.querySelectorAll('.lh-wrapper');
    
    elements.forEach(element => {
      const elementTop = element.getBoundingClientRect().top;
      const elementBottom = element.getBoundingClientRect().bottom;
      
      if (elementTop < window.innerHeight && elementBottom > 0) {
        element.classList.add('animate');
      }
    });
  };

  // Listen for scroll events
  window.addEventListener('scroll', animateOnScroll);
  
  // Initial check for elements in view
  animateOnScroll();

  // Handle image loading
  const handleImages = function() {
    const images = document.querySelectorAll('.lh-img img');
    
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function() {
          this.classList.add('loaded');
        });
      }
    });
  };

  // Initialize image handling
  handleImages();

  // Add hover effects for buttons
  const buttons = document.querySelectorAll('.lh-btn a');
  
  buttons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });

})(); 